import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavBar, Toast } from 'antd-mobile';
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import { t } from 'i18next';
import DynamSoftScanComponent from 'components/ScanComponent/DynamSoftScanComponent';
import customTopToast from 'components/CustomTopToast';
import { ExclamationCircleFill } from "antd-mobile-icons";

const ScanPackageVerification: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // 获取传递的目标路由信息
    const targetPath = location.state?.targetPath;
    const targetState = location.state?.targetState;
    const trackingNumber = location.state?.targetState?.trackingNumber;

    // 处理扫描结果
    sessionStorage.setItem('returningFromDetail', 'true');
    const handleScanSuccess = async (id: string) => {
        // 校验扫描的id和trackingNumber是否一致
        if (trackingNumber && id !== trackingNumber) {
            customTopToast.show({
                content: (
                    <div className="flex items-center justify-center gap-2">
                        <ExclamationCircleFill className="text-2xl text-yellow-500" />
                        <span className="text-xs text-white">{t('pages.delivery.task.transferIn.packageNotBelongToStop')}</span>
                    </div>
                ),
                position: 'top',
                duration: 2000
            });
            return;
        }
        navigate(targetPath, { state: targetState, replace: true });
    }

    return (
        <div className="flex flex-col h-screen bg-white">
            {/* Navbar - 固定在顶部 */}
            <div {...getNavBarContainerStyle()}>
                <NavBar onBack={() => navigate(-1)}>
                    {t('pages.useMenu.scanPackage')}
                </NavBar>
            </div>
            {/* 主要内容区域 */}
            <DynamSoftScanComponent onScanSuccess={handleScanSuccess} showManualInputIcon={true} />
        </div>
    );
};

export default ScanPackageVerification;